/**
 * Identité de l'éditeur, reprise dans le pied des e-mails de prospection
 * (shared/lib/prospection/). Les pages légales elles-mêmes vivent dans le site
 * vitrine (site/src/content/pages/) : à tenir à jour ensemble, avec l'extrait
 * Kbis. Module neutre (aucune dépendance serveur), importable partout.
 */

import { DEFAULT_LOCALE, type Locale } from "@shared/i18n/locales";
import { SITE_URL } from "@shared/lib/hosts";

export const LEGAL_ENTITY = {
  brand: "Hune",
  name: "Caresquad",
  legalForm: "société par actions simplifiée (SAS)",
  /** Montant du capital social, tel qu'il figure au Kbis (ex. « 1 000 € »). */
  shareCapital: null as string | null,
  address: "7 rue Castillon, 33000 Bordeaux, France",
  city: "Bordeaux",
  siren: "945 001 832",
  siret: "945 001 832 00027",
  rcs: "RCS Bordeaux 945 001 832",
  vatNumber: "FR88 945 001 832",
  publicationDirector: "Romain Gattegno, président",
  email: "contact@hune-app.com",
  /** Numéro de téléphone de l'éditeur (LCEN, art. 6). */
  phone: null as string | null,
  domain: "hune-app.com",
} as const;

/** Legal pages of the marketing site, in each language (site/src/i18n/routes.ts). */
export type LegalPage = "terms" | "termsOfSale" | "privacy" | "legalNotice";

const LEGAL_PATHS: Record<LegalPage, Record<Locale, string>> = {
  terms: { fr: "/cgu", en: "/en/terms" },
  termsOfSale: { fr: "/cgv", en: "/en/terms-of-sale" },
  privacy: { fr: "/confidentialite", en: "/en/privacy" },
  legalNotice: { fr: "/mentions-legales", en: "/en/legal-notice" },
};

/** Address of a legal page on the marketing site; French by default (admin, emails). */
export function legalUrl(page: LegalPage, locale: Locale = DEFAULT_LOCALE, hash = "") {
  return `${SITE_URL}${LEGAL_PATHS[page][locale]}${hash}`;
}
